import React from 'react';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

interface ChevronLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  href: string;
  title: string;
  icon?: IconDefinition;
  key?: React.Key;
}

const ChevronLink = ({ href, icon, title }: ChevronLinkProps) => {
  return (
    <div className="max-w-full flex items-center gap-3 mb-2 last:mb-0">
      <FontAwesomeIcon
        icon={icon ?? faChevronRight as IconProp}
        className="text-stone-400"
      />
      <a
        href={href}
        className="block py-1 text-blue-600 hover:text-blue-700 font-bold text-sm md:text-lg no-underline truncate"
      >
        {title}
      </a>
    </div>
  );
};

export default ChevronLink;